import { InteractionsServiceConstants } from "@agentx/agentx-services";
import { logger } from "../logger/store-logger";
function parseJsonProperties(jsonString) {
    try {
        return jsonString ? JSON.parse(jsonString) : [];
    }
    catch (error) {
        logger.error("[Interactions-Store] Error parsing JSON properties:", error);
    }
    return [];
}
function determineCustomerIdAndDnis(contactDirection, origin, destination) {
    let customerId;
    let dnis;
    if (contactDirection === "inbound") {
        customerId = origin;
        dnis = destination;
    }
    else {
        customerId = destination;
        dnis = origin;
    }
    return { customerId: customerId !== null && customerId !== void 0 ? customerId : "", dnis: dnis !== null && dnis !== void 0 ? dnis : "" };
}
export function mapContactStatsToStoreData(contactStats) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const participantAgents = parseJsonProperties(contactStats.data.participatingAgentList);
    const requiredSkills = (_a = contactStats.data.requiredSkills) !== null && _a !== void 0 ? _a : [];
    const matchedSkills = (_b = contactStats.data.matchedSkills) !== null && _b !== void 0 ? _b : [];
    const globalVariables = parseJsonProperties(contactStats.data.globalVariables).map((globalVariable) => ({ key: globalVariable.name, val: globalVariable.value }));
    const { customerId, dnis } = determineCustomerIdAndDnis(contactStats.data.contactDirection, contactStats.data.origin, contactStats.data.destination);
    return {
        id: contactStats.data.interactionId,
        channel: {
            channelType: contactStats.data.channelType
        },
        startTime: contactStats.data.contactIngestionTimestamp,
        endTime: 0,
        customerName: (_c = contactStats.data.customerName) !== null && _c !== void 0 ? _c : "",
        customerId,
        direction: contactStats.data.contactDirection,
        entryPoint: (_d = contactStats.data.entrypointName) !== null && _d !== void 0 ? _d : "",
        queue: (_e = contactStats.data.queueName) !== null && _e !== void 0 ? _e : "",
        queueId: (_f = contactStats.data.queueId) !== null && _f !== void 0 ? _f : "",
        previousQueue: (_g = contactStats.data.previousQueueName) !== null && _g !== void 0 ? _g : "",
        team: contactStats.data.teamName,
        site: contactStats.data.siteName,
        contactStatus: contactStats.data.eventName,
        agent: {
            name: contactStats.data.agentName,
            email: contactStats.data.agentId
        },
        csat: 0,
        handleTime: { duration: 0 },
        transfers: 0,
        isTransferred: ((_h = contactStats.data) === null || _h === void 0 ? void 0 : _h.isTransferred) === "true",
        blindTransfers: (_j = contactStats.data.blindTransferCount) !== null && _j !== void 0 ? _j : 0,
        holdTime: { duration: 0 },
        holdTimeStartTimestamp: {
            createdTime: (_k = contactStats.data.holdTimestamp) !== null && _k !== void 0 ? _k : 0,
            isActive: true
        },
        wrapUpTime: { duration: 0 },
        totalContactDuration: { duration: 0 },
        totalContactDurationStartTimestamp: {
            createdTime: (_l = contactStats.data.contactIngestionTimestamp) !== null && _l !== void 0 ? _l : 0,
            isActive: true
        },
        recipients: contactStats.data.emailToList ? contactStats.data.emailToList.split(",").map((s) => s.trim()) : [],
        ccRecipients: contactStats.data.emailCcList ? contactStats.data.emailCcList.split(",").map((s) => s.trim()) : [],
        emailSubject: (_m = contactStats.data.emailSubject) !== null && _m !== void 0 ? _m : "",
        wrapUpReason: "",
        participants: participantAgents,
        skills: [...requiredSkills.map((skill) => skill.name), ...matchedSkills.map((skill) => skill.name)],
        queuedFrom: contactStats.data.queuedFrom || "",
        transferredByAgent: contactStats.data.transferredByAgent || "",
        waitTime: { duration: 0 },
        waitTimeStartTimestamp: contactStats.data.contactRoutingState === InteractionsServiceConstants.ContactRoutingState.Queued
            ? {
                createdTime: contactStats.data.contactRoutingStateTimestamp || 0,
                isActive: true
            }
            : { createdTime: 0, isActive: false },
        hasRecording: contactStats.data.recording ? true : false,
        agentId: contactStats.data.agentId,
        agentPhoneNumber: contactStats.data.destinationAgentDNIS || "",
        wrapUpCodeId: "",
        customerEmail: "",
        customerPhoneNumber: "",
        origin: contactStats.data.origin,
        isActive: ((_o = contactStats.data) === null || _o === void 0 ? void 0 : _o.isConnected) === "true",
        dnis,
        emailHasAttachments: ((_p = contactStats.data) === null || _p === void 0 ? void 0 : _p.emailHasAttachments) === "true",
        globalVariables,
        interactionDuration: { duration: 0 },
        interactionDurationStartTimestamp: {
            createdTime: contactStats.data.contactRoutingState === InteractionsServiceConstants.ContactRoutingState.Assigned
                ? contactStats.data.contactRoutingStateTimestamp || 0
                : 0,
            isActive: true
        }
    };
}
export function mapTaskDetailsToStoreData(task) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8;
    const { customerId, dnis } = determineCustomerIdAndDnis(task.direction, task.origin, task.destination);
    return {
        id: task.id,
        channel: {
            channelType: task.channelType,
            channelSubType: task.channelSubType ? task.channelSubType : undefined
        },
        startTime: task.createdTime,
        endTime: task.endedTime,
        customerName: (_a = task.customer) === null || _a === void 0 ? void 0 : _a.name,
        customerId,
        direction: task.direction,
        entryPoint: (_b = task.lastEntryPoint) === null || _b === void 0 ? void 0 : _b.name,
        queue: (_d = (_c = task.lastQueue) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : "",
        queueId: (_f = (_e = task.lastQueue) === null || _e === void 0 ? void 0 : _e.id) !== null && _f !== void 0 ? _f : "",
        previousQueue: (_h = (_g = task.previousQueue) === null || _g === void 0 ? void 0 : _g.name) !== null && _h !== void 0 ? _h : "",
        team: (_j = task.lastTeam) === null || _j === void 0 ? void 0 : _j.name,
        site: (_k = task.lastSite) === null || _k === void 0 ? void 0 : _k.name,
        contactStatus: task.status,
        agent: {
            name: (_m = (_l = task.lastAgent) === null || _l === void 0 ? void 0 : _l.name) !== null && _m !== void 0 ? _m : "",
            email: (_p = (_o = task.lastAgent) === null || _o === void 0 ? void 0 : _o.signInId) !== null && _p !== void 0 ? _p : ""
        },
        csat: task.csatScore,
        handleTime: { duration: task.connectedDuration + task.holdDuration + task.postCallDuration + task.wrapupDuration },
        isTransferred: task.transferCount > 0,
        transfers: task.transferCount,
        blindTransfers: task.blindTransferCount,
        holdTime: { duration: (_q = task.holdDuration) !== null && _q !== void 0 ? _q : 0 },
        holdTimeStartTimestamp: { createdTime: 0, isActive: false },
        wrapUpTime: { duration: (_r = task.wrapupDuration) !== null && _r !== void 0 ? _r : 0 },
        totalContactDuration: { duration: task.totalDuration },
        totalContactDurationStartTimestamp: {
            createdTime: 0,
            isActive: false
        },
        recipients: (_t = (_s = task.emailToList) === null || _s === void 0 ? void 0 : _s.split(";")) !== null && _t !== void 0 ? _t : [],
        ccRecipients: (_v = (_u = task.emailCcList) === null || _u === void 0 ? void 0 : _u.split(";")) !== null && _v !== void 0 ? _v : [],
        emailSubject: (_x = (_w = task.channelMetaData) === null || _w === void 0 ? void 0 : _w.email) === null || _x === void 0 ? void 0 : _x.subject,
        wrapUpReason: task.lastWrapupCodeName,
        participants: [],
        skills: [
            ...((_z = (_y = task.requiredSkills) === null || _y === void 0 ? void 0 : _y.map((skill) => skill.name)) !== null && _z !== void 0 ? _z : []),
            ...((_1 = (_0 = task.matchedSkills) === null || _0 === void 0 ? void 0 : _0.map((skill) => skill.name)) !== null && _1 !== void 0 ? _1 : [])
        ],
        queuedFrom: "",
        transferredByAgent: task.previousAgentName,
        waitTime: { duration: task.queueDuration },
        waitTimeStartTimestamp: { createdTime: 0, isActive: false },
        hasRecording: task.captureRequested && !task.isRecordingDeleted,
        agentId: (_3 = (_2 = task.lastAgent) === null || _2 === void 0 ? void 0 : _2.id) !== null && _3 !== void 0 ? _3 : "",
        agentPhoneNumber: (_5 = (_4 = task.lastAgent) === null || _4 === void 0 ? void 0 : _4.phoneNumber) !== null && _5 !== void 0 ? _5 : "",
        wrapUpCodeId: task.lastWrapUpCodeId,
        customerEmail: (_6 = task.customer) === null || _6 === void 0 ? void 0 : _6.email,
        customerPhoneNumber: (_7 = task.customer) === null || _7 === void 0 ? void 0 : _7.phoneNumber,
        origin: task.origin,
        isActive: task.isActive,
        dnis,
        emailHasAttachments: (_8 = task.emailHasAttachments) !== null && _8 !== void 0 ? _8 : false,
        globalVariables: [],
        interactionDuration: {
            duration: task.connectedDuration + task.holdDuration + task.postCallDuration
        },
        interactionDurationStartTimestamp: { createdTime: 0, isActive: false } // not available in search API
    };
}
